import React from "react";
import * as palette from "../palette";
import FocusOnMount from "../FocusOnMount";
import { Value } from "react-powerplug";
import Filestack, { FILESTACK_CONTAINER_ID } from "../Filestack";

export default function ImageInput({ onChange, initialValues, saveButtonText }) {
  return (
    <div
      css={{
        width: 300,
      }}
    >
      <FocusOnMount nextTick={false}>
        {({ innerRef }) => (
          <Value
            initial={{
              url: initialValues ? initialValues.url || "" : "",
              alt: initialValues ? initialValues.alt || "" : "",
            }}
          >
            {({ value, set }) => (
              <div
                css={{
                  width: "100%",
                  padding: 16,
                  background: "#eeeeee",
                }}
              >
                <div
                  css={{
                    minHeight: "120px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {value && value.url && (
                    <div
                      css={{
                        position: "relative",
                      }}
                    >
                      <img
                        src={value.url}
                        css={{
                          width: "100%",
                          borderRadius: 5,
                          objectFit: "cover",
                        }}
                      />

                      <div
                        css={{
                          position: "absolute",
                          top: -4,
                          right: -4,
                          width: 28,
                          height: 28,
                          borderRadius: 25,
                          background: "#FE786C",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 600,
                          cursor: "pointer",
                          "&:hover": {
                            top: -4,
                            right: -4,
                            background: "#FE5F51",
                          },
                        }}
                        onClick={() => {
                          set({
                            url: "",
                            alt: value.alt,
                          });
                        }}
                      >
                        X
                      </div>
                    </div>
                  )}

                  {!value.url && (
                    <div
                      id={FILESTACK_CONTAINER_ID}
                      css={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                    >
                      <Filestack
                        onChange={(url) => {
                          set({
                            url,
                            alt: value.alt,
                          });
                        }}
                      />
                    </div>
                  )}
                </div>

                <div
                  css={{
                    marginTop: 8,
                  }}
                >
                  <label
                    css={{
                      color: palette.sealBlue,
                    }}
                  >
                    Image url
                  </label>
                </div>

                <div
                  css={{
                    marginTop: 4,
                  }}
                >
                  <input
                    ref={innerRef}
                    value={value.url}
                    placeholder="Type image url..."
                    spellCheck={false}
                    css={{
                      border: `1px solid ${palette.lightGray}`,
                      borderRadius: 2,
                      outline: "none",
                      backgroundColor: "white",
                      padding: 4,
                      color: palette.text,
                      width: "100%",
                    }}
                    onChange={(event) =>
                      set({
                        url: event.target.value,
                        alt: value.alt,
                      })
                    }
                  />
                </div>

                <div
                  css={{
                    marginTop: 8,
                  }}
                >
                  <label
                    css={{
                      color: palette.sealBlue,
                    }}
                  >
                    Image alt text
                  </label>
                </div>

                <div
                  css={{
                    marginTop: 4,
                  }}
                >
                  <input
                    value={value.alt}
                    placeholder="Type image alt text..."
                    spellCheck={false}
                    css={{
                      border: `1px solid ${palette.lightGray}`,
                      borderRadius: 2,
                      outline: "none",
                      backgroundColor: "white",
                      padding: 4,
                      color: palette.text,
                      width: "100%",
                    }}
                    onChange={(event) =>
                      set({
                        url: value.url,
                        alt: event.target.value,
                      })
                    }
                  />
                </div>

                <div
                  css={{
                    marginTop: 8,
                  }}
                >
                  <button
                    type="button"
                    disabled={!value.url || !value.alt}
                    css={{
                      outline: "none",
                      borderRadius: 4,
                      cursor: !value.url || !value.alt ? "default" : "pointer",
                      pointerEvents: !value.url || !value.alt ? "none" : "all",
                      border: "solid 1px transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 12,
                      height: 30,
                      padding: "0 20px",
                      backgroundColor: !value.url || !value.alt ? palette.lightGray : palette.primary,
                      color: "#ffffff",
                      "&:hover:not(:focus)": {
                        opacity: 0.8,
                      },
                    }}
                    onClick={() => onChange(value.url, value.alt)}
                  >
                    {saveButtonText || "Add Image"}
                  </button>
                </div>
              </div>
            )}
          </Value>
        )}
      </FocusOnMount>
    </div>
  );
}
